/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterInputOutputKind = (typeof FilterInputOutputKind)[keyof typeof FilterInputOutputKind];

export const FilterInputOutputKind = {
  input_output: 'input_output',
} as const;
